import { actionTypes } from 'app/types/action_types';

const initialState = {
  user: {},
};

const mapInitialPayloadAction = (state, payload) => ({
  ...state,
  ...payload.user,
});

// eslint-disable-next-line default-param-last
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE:
      return mapInitialPayloadAction(state, action.payload);
    default:
      return state;
  }
};

export default userReducer;
